<ng-container *transloco="let t">
  <h3 class="section-title">{{ t('fnaFormTitle') }}</h3>

  <div class="field-block" [formGroup]="form">
    <div class="field-item" formGroupName="rtgInterpretation">
      <label class="field-title">{{ t('rtgInterpretation') }}</label>
      <mat-form-field appearance="outline" class="w-full">
        <mat-label>{{ t('rtgInterpretation') }} </mat-label>
        <textarea matInput [formControlName]="currentLang" rows="4"></textarea>
      </mat-form-field>
    </div>

    <div class="field-item" formGroupName="fnaInterpretation">
      <label class="field-title">{{ t('fnaInterpretation') }}</label>
      <mat-form-field appearance="outline" class="w-full">
        <mat-label>{{ t('fnaInterpretation') }} </mat-label>
        <textarea matInput [formControlName]="currentLang" rows="4"></textarea>
      </mat-form-field>
    </div>

    <div class="field-item" formGroupName="fnaDiagnosis">
      <label class="field-title">{{ t('fnaDiagnosis') }}</label>
      <mat-form-field appearance="outline" class="w-full">
        <mat-label>{{ t('fnaDiagnosis') }} </mat-label>
        <textarea matInput [formControlName]="currentLang" rows="4"></textarea>
      </mat-form-field>
    </div>

    <div class="field-item" formGroupName="therapy">
      <label class="field-title">{{ t('therapy') }}</label>
      <mat-form-field appearance="outline" class="w-full">
        <mat-label>{{ t('therapy') }} </mat-label>
        <textarea matInput [formControlName]="currentLang" rows="4"></textarea>
      </mat-form-field>
    </div>

    <div class="field-item" formGroupName="note">
      <label class="field-title">{{ t('note') }}</label>
      <mat-form-field appearance="outline" class="w-full">
        <mat-label>{{ t('note') }} </mat-label>
        <textarea matInput [formControlName]="currentLang" rows="4"></textarea>
      </mat-form-field>
    </div>

    <div class="field-item">
      <mat-form-field appearance="outline" class="w-full">
        <mat-label>{{ t('veterinarianName') }}</mat-label>
        <input matInput formControlName="veterinarianName" />
        <mat-error>{{ t('This field is required') }}</mat-error>
      </mat-form-field>
    </div>
  </div>
</ng-container>
